/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_Custom_Input_LabelInputs */

const es_components_buy_messages_modal_custom_input_label = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad de mensajes`)
};

const en_components_buy_messages_modal_custom_input_label = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of messages`)
};

/**
* | output |
* | --- |
* | "Number of messages" |
*
* @param {Components_Buy_Messages_Modal_Custom_Input_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_custom_input_label = /** @type {((inputs?: Components_Buy_Messages_Modal_Custom_Input_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_Custom_Input_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_custom_input_label(inputs)
	return en_components_buy_messages_modal_custom_input_label(inputs)
});
export { components_buy_messages_modal_custom_input_label as "components.buy_messages_modal.custom.input_label" }